import { useMemo } from 'react';
import { formatJSONObjectString } from './formatJSONObjectString';
import CodeBlockVirtual from './index';
import clsx from 'clsx';

export function FormatJSONCodeBlock(props: React.ComponentProps<typeof CodeBlockVirtual>) {
  const formatCode = useMemo(() => {
    return formatJSONObjectString(props.code);
  }, [props.code]);
  return <CodeBlockVirtual {...props} code={formatCode} className={clsx('markdown-code-block', props.className)} />;
}
